import type { AssetView } from "../api/AssetView";
import { AssetIcon } from "../components/AssetIcon";

type AssetListProps = {
  // Подпись перед списком, например «Сильные игроки берут:».
  label?: string;
  entries: readonly { asset: AssetView; caption?: string }[];
};

// Строка героев или предметов с иконками и названиями — часть карточки находки.
export const AssetList = ({ label, entries }: AssetListProps) =>
  entries.length === 0 ? null : (
    <div className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1.5 text-sm text-muted">
      {label !== undefined && <span className="text-foreground-soft">{label}</span>}
      <ul className="flex flex-wrap gap-x-3 gap-y-1.5">
        {entries.map(({ asset, caption }, index) => (
          <li key={`${asset.id}-${index}`} className="flex items-center gap-1.5" title={asset.name}>
            <AssetIcon asset={asset} size={28} className="rounded-md" />
            <span className="text-foreground">{asset.name}</span>
            {caption !== undefined && <span>{caption}</span>}
          </li>
        ))}
      </ul>
    </div>
  );
